import { Maybe } from 'monet';
import Date from '@/components/NotificationPlan/Date.vue';
import Dynamic from '@/components/NotificationPlan/Dynamic.vue';
import Text from '@/components/NotificationPlan/Text.vue';

/**
 * @description Типы фрагментов шаблона.
 * @type {any[]}
 */
const FRAGMENT_TYPES = [
  {
    fragmentName: 'Дата приема',
    group: 'Прием',
    is: Dynamic.name,
    example: '12.02.2024',
  },
  {
    fragmentName: 'Время приема',
    group: 'Прием',
    is: Dynamic.name,
    example: '12:00',
  },
  {
    fragmentName: 'Указатель дня',
    group: 'Прием',
    is: Dynamic.name,
    example: 'Понедельник',
  },
  {
    fragmentName: 'Адрес клиники',
    group: 'Клиника',
    is: Dynamic.name,
    example: 'ул. Можайское шоссе, д.10',
  },
  {
    fragmentName: 'Название клиники',
    group: 'Клиника',
    is: Dynamic.name,
    example: 'РУДЕНТ',
  },
  {
    fragmentName: 'Телефон клиники',
    group: 'Клиника',
    is: Dynamic.name,
    example: 'тел. +7 (999) 999-99-99',
  },
  {
    fragmentName: 'Имя пациента',
    group: 'Пациент',
    is: Dynamic.name,
    example: 'Иван',
  },
  {
    fragmentName: 'Фамилия пациента',
    group: 'Пациент',
    is: Dynamic.name,
    example: 'Сергеев',
  },
  {
    fragmentName: 'Отчество пациента',
    group: 'Пациент',
    is: Dynamic.name,
    example: 'Сергеевич',
  },
  {
    fragmentName: 'Название услуги',
    group: 'Услуга',
    is: Dynamic.name,
    example: 'Лечение кариеса',
  },
  {
    fragmentName: 'Фамилия и инициалы доктора',
    group: 'Прием',
    is: Dynamic.name,
    example: 'Сергеев И.В.',
  },
  {
    fragmentName: 'Текст',
    is: Text.name,
  },
];

/**
 * @description Найти тип фрагмента шаблона по названию.
 * @param {{name: string}} fragment Фрагмент.
 * @returns {Maybe<Object>}
 */
const findFragmentTypeByName = (fragment) => Maybe.fromUndefined(
  FRAGMENT_TYPES.find((type) => type.fragmentName === fragment.name),
);

/**
 * @description Компоненты фрагментов шаблона.
 * @type {any}
 */
export const templateFragmentComponents = {
  [Date.name]: Date,
  [Dynamic.name]: Dynamic,
  [Text.name]: Text,
};

/**
 * @description Примесь шаблона СМС.
 */
export default {
  methods: {
    /**
     * @description Проверить допустимость фрагмента по названию.
     * @param {{name: string}} fragment Фрагмент.
     * @returns {boolean}
     */
    hasFragmentTypeByName: (fragment) => findFragmentTypeByName(fragment)
      .isSome(),
    /**
     * @description Объединить фрагмент с параметрами его типа.
     * @param {{name: string}} fragment Фрагмент.
     * @returns {Maybe<Object>}
     */
    mergeWithFragmentParams: (fragment) => findFragmentTypeByName(fragment)
      .bind((type) => (
        {
          group: type.group,
          component: type.is,
          example: type.example,
          ...fragment,
        }
      )),
  },
};
